import React, { useState, useEffect } from 'react';

const MaintenancePage = () => {
  // State for the countdown timer
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 2,
    seconds: 41,
  });

  // Effect to handle the countdown logic
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }

        let newSeconds = prev.seconds - 1;
        let newMinutes = prev.minutes;
        let newHours = prev.hours;

        if (newSeconds < 0) {
          newSeconds = 59;
          newMinutes -= 1;
        }
        if (newMinutes < 0) {
          newMinutes = 59;
          newHours -= 1;
        }

        return { hours: newHours, minutes: newMinutes, seconds: newSeconds };
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // Helper to format numbers
  const formatTime = (time) => (time < 10 ? `0${time}` : time);

  return (
    <div className="relative min-h-screen bg-black text-white font-sans flex items-center justify-center p-6 overflow-hidden">
      
      {/* BACKGROUND EFFECTS */}
      {/* Pink Glow Blob Top Right */}
      <div className="absolute top-[-10%] right-[-5%] w-96 h-96 bg-pink-600 rounded-full mix-blend-screen filter blur-[128px] opacity-40 animate-pulse"></div>
      {/* Purple/Pink Glow Blob Bottom Left */}
      <div className="absolute bottom-[-10%] left-[-10%] w-[500px] h-[500px] bg-pink-900 rounded-full mix-blend-screen filter blur-[128px] opacity-30"></div>

      <div className="relative z-10 max-w-7xl w-full grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        
        {/* LEFT SECTION: Text & Info */}
        <div className="flex flex-col space-y-8 animate-fade-in-up">
          
          {/* Logo */}
          <div className="flex items-center space-x-3">
           
            <div className="text-2xl font-bold tracking-widest text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400 uppercase">
              Kalyana Matrimony
            </div>
          </div>

          {/* Main Headline */}
          <div className="space-y-6">
            <h1 className="text-5xl md:text-7xl font-extrabold leading-tight">
              <span className="block text-white">We are</span>
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-500 via-pink-400 to-white drop-shadow-[0_0_15px_rgba(236,72,153,0.5)]">
                Upgrading.
              </span>
            </h1>
            
            <p className="text-lg md:text-xl text-gray-300 font-light max-w-lg border-l-4 border-pink-600 pl-6 py-2 bg-white/5 backdrop-blur-sm rounded-r-lg">
              We are enhancing our servers to provide you with a <span className="text-pink-400 font-semibold">Matchmaking experience</span>.
            </p>
          </div>

          {/* Countdown Timer Card */}
          <div className="py-8">
            <p className="text-pink-400 mb-4 font-semibold tracking-wider text-sm uppercase">System Relaunch In</p>
            
            {/* Glassy Timer Container */}
            <div className="inline-flex items-center space-x-4 md:space-x-8 p-6 md:p-8 rounded-2xl bg-white/5 border border-white/10 backdrop-blur-xl shadow-[0_0_40px_-10px_rgba(236,72,153,0.3)]">
              
              {/* Hours */}
              <div className="flex flex-col items-center">
                <span className="text-5xl md:text-6xl font-bold text-white drop-shadow-[0_0_10px_rgba(255,255,255,0.5)]">
                  {formatTime(timeLeft.hours)}
                </span>
                <span className="text-xs text-gray-400 uppercase mt-2 tracking-widest">Hours</span>
              </div>

              <span className="text-4xl text-pink-500 pb-6 animate-pulse">:</span>

              {/* Minutes */}
              <div className="flex flex-col items-center">
                <span className="text-5xl md:text-6xl font-bold text-white drop-shadow-[0_0_10px_rgba(255,255,255,0.5)]">
                  {formatTime(timeLeft.minutes)}
                </span>
                <span className="text-xs text-gray-400 uppercase mt-2 tracking-widest">Mins</span>
              </div>

              <span className="text-4xl text-pink-500 pb-6 animate-pulse">:</span>

              {/* Seconds */}
              <div className="flex flex-col items-center">
                <span className="text-5xl md:text-6xl font-bold text-pink-500 drop-shadow-[0_0_20px_rgba(236,72,153,0.8)]">
                  {formatTime(timeLeft.seconds)}
                </span>
                <span className="text-xs text-gray-400 uppercase mt-2 tracking-widest">Secs</span>
              </div>

            </div>
          </div>
        </div>

        {/* RIGHT SECTION: Illustration */}
        <div className="flex justify-center items-center relative">
           {/* Illustration Glow Behind */}
           <div className="absolute inset-0 bg-gradient-to-tr from-pink-600/20 to-transparent rounded-full blur-3xl transform scale-75"></div>
           
           <img 
            src="https://img.freepik.com/free-vector/maintenance-concept-illustration_114360-391.jpg?t=st=1734937215~exp=1734940815~hmac=621743015f60689b917025805545300b848c5b96874415555436662998064d14&w=826" 
            alt="Maintenance Illustration"
            // Adding a custom "float" animation using CSS or arbitrary tailwind values if configured, 
            // here using a simple combine of translation and drop shadow
            className="relative z-10 w-full max-w-lg object-contain drop-shadow-[0_20px_50px_rgba(236,72,153,0.3)] animate-[bounce_6s_infinite]"
            style={{ animation: 'float 6s ease-in-out infinite' }}
          />
        </div>

      </div>

      {/* Custom Keyframe Styles for the 'float' animation */}
      <style>{`
        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
          100% { transform: translateY(0px); }
        }
        .animate-fade-in-up {
          animation: fadeInUp 0.8s ease-out forwards;
        }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default MaintenancePage;